import { combineReducers } from 'redux';

import checkout from './checkout';
import checkoutTerms from './checkoutTerms';
import examples from './example';
import info from './info';
import simpleProduct from './simpleProduct';
import me from './me';
import products from './products';
import shopCart from './shopCart';
import pendingData from './pendingData';
import cartErrors from './cartErrors';
import order from './order';
import productsSet from './productsSet';

const rootReducer = combineReducers({
    checkout,
    checkoutTerms,
    examples,
    info,
    simpleProduct,
    me,
    products: products.reducers,
    shopCart,
    pendingData,
    cartErrors,
    order,
    productsSet,
});

export default rootReducer;
